function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
// ----------------------------------------------------------------------------
// Web Component: iamCartSummary <iam-cart-summary>
// Extends: HTMLElement
// ----------------------------------------------------------------------------
// TODO
// ----------------------------------------------------------------------------
// Customization:
// - TODO
// ----------------------------------------------------------------------------
// Event Listeners:
// - `cart:modified`       → Listens for when the cart is modified
// ----------------------------------------------------------------------------
// Event Triggers:
// - `cartForm:summary:updated`    → Triggers when the cart summary is updated
// ----------------------------------------------------------------------------
// Key Data Mutations:
// - Fetches cart summary data and updates the cart summary section
// ----------------------------------------------------------------------------
// Gotchas:
// - Relies on promises to fetch cart summary data, which may fail if the API calls do not resolve successfully.
// - Error messages are injected into the `.summary__errors-container` element
//   and the summary is marked with a `--error` class until resolved
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Helpers
import iamFormElement from 'scripts/classes/iamFormElement';
import iamotaEventHandler from 'scripts/helpers/iamota-event-handler';
import { sectionRendering } from 'scripts/helpers/iamota-shopify-ajax';
import translate from 'scripts/helpers/iamota-translate';

// Elements
import '../checkout-button/checkout-button';
//import 'snippets/free-shipping-progress/free-shipping-progress';

// Styles
import './_cart-summary.scss';

// -------------------------------------
// Web Component
// -------------------------------------

class iamCartSummary extends iamFormElement {
  get namespace() {
    return "".concat(this.formName, ":summary");
  }

  /**
   * Initialize the component when the product form is initialized
   */
  onFormInit() {
    // Variables
    this.cartSummaryContainer = this.querySelector('.cart-summary__content');

    // Bind Event Listeners
    iamotaEventHandler.subscribe('cart:modified', this.onCartModified.bind(this), {
      source: "cart-summary.js"
    });

    // Validation
    if (!this.validateRequiredAttributes(['cartSummaryContainer'])) return;

    // Sticky bar variant: pinned below the site header on tablet/mobile
    if (this.classList.contains('cart-summary--sticky')) this.initStickyBar();
  }

  /**
   * Initialize the sticky bar variant
   * The bar is fixed just below the site header (which is always visible on
   * tablet/mobile) and is revealed once the in-flow cart header summary is
   * scrolled out of view.
   */
  initStickyBar() {
    this.headerSection = document.querySelector('#shopify-section-header');
    this.stickySentinel = document.querySelector('.cart__header');
    this.mainSummary = document.querySelector('.cart__sidebar .cart__summary iam-checkout-button');
    if (!this.stickySentinel) return;
    this.headerScrolledOut = false;
    this.mainSummaryInView = false;
    this.updateStickyBarPosition();
    this.observeMainSummary();

    // Track header height changes (viewport resize, announcement bar, etc.)
    if ('ResizeObserver' in window && this.headerSection) {
      this.headerResizeObserver = new ResizeObserver(this.updateStickyBarPosition.bind(this));
      this.headerResizeObserver.observe(this.headerSection);
    } else {
      window.addEventListener('resize', this.updateStickyBarPosition.bind(this));
    }
  }
  updateStickyBarPosition() {
    var _this$headerSection;
    var headerHeight = ((_this$headerSection = this.headerSection) === null || _this$headerSection === void 0 ? void 0 : _this$headerSection.offsetHeight) || 0;
    this.style.setProperty('--cart-sticky-bar-top', "".concat(headerHeight, "px"));
    this.observeStickySentinel(headerHeight);
  }
  observeStickySentinel(headerHeight) {
    var _this$stickySentinelO;
    (_this$stickySentinelO = this.stickySentinelObserver) === null || _this$stickySentinelO === void 0 || _this$stickySentinelO.disconnect();

    // The in-flow summary disappears under the sticky header rather than at
    // the viewport edge, so inset the observed area by the header height
    this.stickySentinelObserver = new IntersectionObserver(_ref => {
      var [entry] = _ref;
      this.headerScrolledOut = !entry.isIntersecting;
      this.updateStickyVisibility();
    }, {
      rootMargin: "-".concat(headerHeight, "px 0px 0px 0px")
    });
    this.stickySentinelObserver.observe(this.stickySentinel);
  }

  // Hide the sticky bar once the main in-page checkout button scrolls into view
  observeMainSummary() {
    var _this$mainSummaryObse;
    if (!this.mainSummary) return;
    (_this$mainSummaryObse = this.mainSummaryObserver) === null || _this$mainSummaryObse === void 0 || _this$mainSummaryObse.disconnect();
    this.mainSummaryObserver = new IntersectionObserver(_ref2 => {
      var [entry] = _ref2;
      this.mainSummaryInView = entry.isIntersecting;
      this.updateStickyVisibility();
    });
    this.mainSummaryObserver.observe(this.mainSummary);
  }
  updateStickyVisibility() {
    this.classList.toggle('is-visible', this.headerScrolledOut && !this.mainSummaryInView);
  }
  onCartModified() {
    var _this = this;
    this.setLoading(true);
    sectionRendering.fetchSingle('main-cart-summary__content').then(/*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(function* (sectionContent) {
        var cartSummaryHTML = yield iamotaEventHandler.applyFilters('cartForm:summary:updating', sectionContent);
        _this.cartSummaryContainer.innerHTML = cartSummaryHTML;
        iamotaEventHandler.trigger('cartForm:summary:updated', {
          cartSummaryHTML
        }, {
          context: _this
        });
      });
      return function (_x) {
        return _ref3.apply(this, arguments);
      };
    }()).catch(error => {
      console.error('cartForm: Error fetching main-cart-summary__content section:', error);
      this.cartSummaryContainer.innerHTML = translate('An unexpected error occurred when updating the cart summary. Please try reloading the page.', 'cartForm.error_retrieving_cart_summary');
    }).finally(() => {
      this.setLoading(false);
    });
  }
}
customElements.define('iam-cart-summary', iamCartSummary);